import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import useSWR from 'swr';
import { ref, getDatabase, off, onValue, update } from 'firebase/database';
import { CircularProgress as MuiCircularProgress } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import CloseIcon from '@mui/icons-material/Close';
import { dataFetcher, endpoints, axios, baseUrl } from 'Api';
import { logAppEvent } from 'Api/errorLogger';
import RightArrowImg, {
  ReactComponent as RightArrow,
} from 'Assets/category-right-arrow.svg';
import LeftArrowImg, {
  ReactComponent as LeftArrow,
} from 'Assets/category-left-arrow.svg';
import { ProfilePage, ProjectorShimmer } from 'Components';
// import { ApolloClient, InMemoryCache } from '@apollo/client';
import { AppContext, AuthContext } from 'Context';
import { Pathname } from 'Routes';
import ImageGroup from 'Components/ImageGroup/ImageGroup';
import ViewMyProjector from 'Components/ImageGroup/ViewMyProjector';
import PermissionDeniedModal from 'Components/PermissionDeniedModal';
import { getUserContents } from 'Api/apiFunctions';
import uploadManagerSecure, { UPLOAD_STATUS } from 'Utils/uploadManagerSecure';
import useMyAxios from 'hooks/useMyAxios';
// eslint-disable-next-line no-unused-vars -- kept for the commented-out top loader below
import FixedProgressBar from 'Components/header/components/FixedProgressBar';
import DelayedProgressBar from 'Components/DelayedProgressBar';
import { getDisplayName } from 'Utils/utils';
import ThreeDotLoader from 'Components/ThreeDotLoader';
// import/order wants these four below the `swiper/core` import further down.
// Left in place deliberately: these modules pull in global stylesheets
// (react-multi-carousel) and BottomBar is what first evaluates this page's own
// index.module.css — so moving them past `swiper/swiper-bundle.min.css` changes
// the CSS injection order for the whole page. Not worth that risk for a
// stylistic rule; revisit with visual QA if the ordering is cleaned up.
/* eslint-disable import/order */
import { WhatsNew } from '../my-profile/Component/WhatsNew/whatsNew';
import { ImageBanner } from '../my-profile/Component/ImageBanner/imageBanner';
import { AlbumBanner } from '../my-profile/Component/AlbumBanner/albumBanner';
import BottomBar from './BottomBar';
/* eslint-enable import/order */
import RowCarousel from 'Components/reactbits/RowCarousel';
import OptionWheel from 'Components/reactbits/OptionWheel';
import { AnimatedCategory, AnimatedPlaylist, AnimatedAlbum } from 'Components/reactbits/AnimatedIcons';
import { VideoModal } from 'Pages/private/video-details';
import { AlbumModal } from 'Pages/private/album-details/AlbumModal';
import { readProfileBg, useProjectorBg, fxKind, bgSurface } from 'hooks/useProfileBg';
import { SoftAuroraFX, ProjectorAuroraFX } from 'Components/viewer-inner';
// eslint-disable-next-line
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line
import "swiper/swiper-bundle.min.css"; // ✅ Import full Swiper styles
// eslint-disable-next-line
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import styles from './index.module.css';

SwiperCore.use([Navigation, Pagination]);
const CircularProgress = withStyles({
  circle: {
    color: '#fff !important',
  },
})(MuiCircularProgress);

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1.5,
    slidesToSlide: 1, // optional, default to 1.
  },
};
const isTrueValue = true;

const CustomRightArrow = ({ onClick, layoutType }) => (
  <RightArrow
    fontSize="large"
    onClick={onClick}
    aria-label="Go to next slide"
    className={
      layoutType === 3 || layoutType === 4
        ? 'react-multiple-carousel__arrow react-multiple-carousel__arrow--rightx layout_arrow_category'
        : 'react-multiple-carousel__arrow react-multiple-carousel__arrow--rightx custom_arrow_category'
    }
  />
);

const CustomLeftArrow = ({ onClick, layoutType }) => (
  <LeftArrow
    onClick={onClick}
    aria-label="Go to next slide"
    className={
      layoutType === 3 || layoutType === 4
        ? 'react-multiple-carousel__arrow react-multiple-carousel__arrow--leftx layout_arrow_category'
        : 'react-multiple-carousel__arrow react-multiple-carousel__arrow--leftx custom_arrow_category'
    }
  />
);
export const CONTENT_TYPES = {
  categories: 'categories',
  photo_albums: 'photo_album',
  playlists: 'playlists',
  resume: 'Resume Watching',
  first15Videos: 'First 15 Videos',
};

// Snapshot of the last-rendered profile data. Lets a back-navigation from the
// inner page restore instantly instead of refetching — gated by a one-shot
// sessionStorage flag ('skipProfileRefetch') set on the inner page's Back, so
// ordinary /profile visits still fetch fresh.
let profileDataCache = null;

export const Profile = () => {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const navigate = useNavigate();
  const {
    setAppSnackbar,
    userDetails,
    contextLoading,
    setContextLoading,
    setLoadingState,
    langText,
    dataOfCategory,
    setdataOfCategory,
    profileName,
    setProfileName,
    amICalled,
    setTopOrBottom,
    setcategoryLoader,
    loader,
    setLoader,
    categoryLoader,
    profileLoader,
    projectorOwner,
    profileDetails,
    setNeedToShowETA,
    firebaseDatabase,
    backendUrl,
    orderArrange,
    fetchLayoutOrder,
    subscriptionDetails,
  } = useContext(AppContext);
  useEffect(() => {
    sessionStorage.setItem('navigateProfile', `${window.location.pathname}${window.location.search}`);
  }, [window.location.pathname, window.location.search]);
  const { getToken, isInActiveUser } = useContext(AuthContext);
  const urlParams = useParams();
  const [searchParams] = useSearchParams();
  const isFromGift = searchParams.get('fromGift') === 'true';
  const profileID = urlParams?.profileID || userDetails.myId;
  const isMyProfile = !urlParams?.profileID;
  const profileText = langText?.viewProjector;
  const scrollPageRef = useRef(null);
  const [selectedCategoryID, setSelectedCategoryID] = useState(undefined);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loading, setLoading] = useState(true);
  const [shimmerLoading, setShimmerLoading] = useState(true);
  const [profileHeroImage, setProfileHeroImage] = useState(undefined);
  const [resumeWatching, setResumeWatching] = useState([]);
  const [resumeMe, setResumeMe] = useState();
  const [first15Videos, setFirst15Videos] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  const [playlist, setPlaylist] = useState();
  const [categories, setCategories] = useState([]); // categories box on top
  const [subCategories, setSubCategories] = useState([]);
  const [allVideos, setAllVideos] = useState([]);
  const [orderedData, setOrderedData] = useState(undefined);
  const [selectedCategoryTitle, setSelectedCategoryTitle] = useState(undefined);
  const [showArrow, setArrows] = useState(false);
  const [isPublicUser, setPublicUser] = useState(false);
  const [layoutType, setLayoutType] = useState(1);
  const [layoutData, setLayoutData] = useState(undefined);
  const [haveData, checkData] = useState(undefined);
  const [categoryStyleId, setCategoryStyleId] = useState(undefined);
  const [thumbnail, setThumbnail] = useState(undefined);
  const limit = 70; // categories video content limit
  const [start, setStart] = useState(1);
  const [startPL, setStartPL] = useState(1);
  const content_limit = 25; // photo albums limts & categories list limit
  const [content_start, setContentStart] = useState(1);
  const [content_startPL, setContentStartPL] = useState(1);
  const [basicData, setBasicData] = useState();
  const [contentData, setContentData] = useState([]);
  const [playlistData, setPlaylistData] = useState([]);
  const [albumData, setAlbumData] = useState([]);
  const [categoriPagination, setCategoriPagination] = useState([]);
  const [playlistPagination, setPlaylistPagination] = useState([]);
  const [albumPagination, setAlbumPagination] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasContent, setHasContent] = useState(false);
  const [videoOffset, setVideoOffset] = useState({});
  const [isFetching, setIsFetching] = useState(false); // Tracks if a fetch is in progress
  const fetchQueue = useRef([]); // Queue to store pending fetch requests'
  const promiseLock = useRef();
  useEffect(() => {
    if (!subscriptionDetails || !subscriptionDetails.plans) return;

    const lastPlan = subscriptionDetails.plans[subscriptionDetails.plans.length - 1];

    const shouldRedirect = isInActiveUser && lastPlan?.is_trial === '0';
    // || subscriptionDetails?.current_plan === 'Free'
    // || subscriptionDetails?.subscription === null

    if (shouldRedirect) {
      navigate('/dashboard');
    }
  }, [isInActiveUser, subscriptionDetails, navigate]);
  useEffect(() => {
    setTopOrBottom(false);
  }, []);

  // The new-signup upload flow hides the global UploadPanel behind this marker
  // while the user is on /gift-content (that page shows its own progress UI).
  // Reaching /profile means the flow is over and the panel should take over the
  // still-running background uploads, so clear the marker here as well as on
  // gift-content's Next — otherwise any path that skips that click would leave
  // the uploads finishing invisibly.
  useEffect(() => {
    try { sessionStorage.removeItem('newUserUploadFlow'); } catch (e) { /* ignore */ }
  }, []);

  const [endLoader, setEndLoader] = useState(false);
  // `loader`/`categoryLoader` live in AppContext and are false/undefined on the
  // very first render (and stale-false when coming back to this page), so the
  // page briefly rendered with empty data — long enough to flash "No Content..."
  // before fetchAllData raised the loader. This local flag is false until THIS
  // mount's initial load has actually finished.
  const [initialLoadDone, setInitialLoadDone] = useState(false);

  const fetchData = async (pageOffset, category_id, categoryVideoOffset) => {
    try {
      const api = `${backendUrl}/graphql`;
      const query = 'query GetCategories($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $commonVideoLimit: Int, $videoSortBy: String, $videoSortOrder: String, $categoryVideoPagination: [CategoryVideoPaginationInput], $vpm: Boolean) { categories(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, commonVideoLimit: $commonVideoLimit, videoSortBy: $videoSortBy, videoSortOrder: $videoSortOrder, categoryVideoPagination: $categoryVideoPagination, vpm: $vpm) { categories { category_id category_name icon videos { id title thumbnails visibility locked_for } videoPagination { total limit offset hasNextPage hasPreviousPage } } pagination { total limit offset hasNextPage hasPreviousPage } } }';

      // Check if current plan is 14 for sort parameters
      const currentPlanId = subscriptionDetails?.subscription?.plan_id
        || subscriptionDetails?.plans?.[subscriptionDetails?.plans?.length - 1]?.plan_id;
      const isPlan14 = String(currentPlanId) === '14';

      const variables = {
        userId: Number(profileID),
        limit: 10,
        offset: pageOffset,
        commonVideoLimit: 10,
        categoryVideoPagination: category_id
          ? [
            {
              categoryId: category_id,
              videoLimit: 10,
              videoOffset: categoryVideoOffset,
            },
          ]
          : [],
        // vpm: false → reverse video order within each category (order_number ASC)
        vpm: false,
        ...(isPlan14 && { videoSortBy: 'date', videoSortOrder: 'ASC' }),
      };

      const response = await axios.post(
        api,
        { query, variables },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      const newData = response?.data?.data?.categories?.categories || [];
      const isPagination = response?.data?.data?.categories?.pagination;
      setCategoriPagination(isPagination);

      if (category_id) {
        // this is for each category
        setContentData((prevData) => prevData?.map((category) => {
          const newCategoryData = newData?.find(
            (c) => c?.category_id === category?.category_id
          );

          if (newCategoryData) {
            const existingVideoIds = new Set(
              category?.videos?.map((v) => v?.id)
            );
            return {
              ...category,
              videos: [
                ...category?.videos,
                ...newCategoryData?.videos?.filter(
                  (video) => !existingVideoIds?.has(video?.id)
                ),
              ],
              videoPagination: newCategoryData?.videoPagination,
            };
          }
          return category;
        }));
      } else {
        // this is for whole category
        setContentData((prevData) => {
          const existingCategoryIds = new Set(
            prevData.map((item) => item?.category_id)
          );
          const uniqueNewData = newData?.filter(
            (item) => !existingCategoryIds.has(item?.category_id)
          );
          // "All Videos" is now freely reorderable, so honor the backend's
          // returned order instead of forcing it to the front.
          return [...prevData, ...uniqueNewData];
        });
      }

      setcategoryLoader(false);
      setEndLoader(false);
    } catch (error) {
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'View Projector',
        description: `Failed to load categories. URL: ${backendUrl}/graphql`,
        severity: 'high',
        errorMessage: error?.response?.data?.message || error?.message || 'Failed to load categories',
        responseStatus: error?.response?.status || null,
        responseBody: error?.response?.data?.message || null,
        requestUrl: `${backendUrl}/graphql`,
        requestMethod: 'POST',
        component: 'Profile',
        userAction: 'View projector called',
      });
      setEndLoader(false);
      console.error('GraphQL Error:', error);
      setcategoryLoader(false);
    } finally {
      // Release the lock by resolving the current promise
      if (promiseLock.current) {
        promiseLock.current.resolve();
        promiseLock.current = null;
      }
    }
  };
  const fetchPlaylistData = async (
    pageOffset,
    playlist_id,
    categoryVideoOffset
  ) => {
    // console.log('🎬 fetchPlaylistData called:', { pageOffset, playlist_id, categoryVideoOffset });
    try {
      const api = `${backendUrl}/get-videos-by-playlist`;
      const query = 'query GetPlaylists($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $commonVideoLimit: Int, $videoSortBy: String, $videoSortOrder: String, $playlistVideoPagination: [PlaylistVideoPaginationInput], $vpm: Boolean) { playlists(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, commonVideoLimit: $commonVideoLimit, videoSortBy: $videoSortBy, videoSortOrder: $videoSortOrder, playlistVideoPagination: $playlistVideoPagination, vpm: $vpm) { playlists { playlist_id playlist_title videos { id title thumbnails visibility locked_for } videoPagination { total limit offset hasNextPage hasPreviousPage } } pagination { total limit offset hasNextPage hasPreviousPage } } }';

      // Check if current plan is 14 for sort parameters
      const currentPlanId = subscriptionDetails?.subscription?.plan_id
        || subscriptionDetails?.plans?.[subscriptionDetails?.plans?.length - 1]?.plan_id;
      const isPlan14 = String(currentPlanId) === '14';

      const variables = {
        userId: Number(profileID),
        limit: 10,
        offset: pageOffset, // ✅ Only use this for page scrolling
        commonVideoLimit: 10,
        playlistVideoPagination: playlist_id
          ? [
            {
              playlistId: playlist_id,
              videoLimit: 10,
              videoOffset: categoryVideoOffset,
            },
          ] // ✅ Use category-specific offset
          : [],
        // vpm: false → reverse video order within each playlist (order_number ASC)
        vpm: false,
        ...(isPlan14 && { videoSortBy: 'date', videoSortOrder: 'ASC' }),
      };
      // console.log('📤 Playlist API payload:', JSON.stringify(variables, null, 2));

      const response = await axios.post(
        api,
        { query, variables },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      const newData = response?.data?.data?.playlists?.playlists || [];
      const isPagination = response?.data?.data?.playlists?.pagination;
      // console.log('📥 Playlist API response:', {
      //   playlistsCount: newData.length,
      //   playlists: newData.map((p) => ({
      //     id: p.playlist_id,
      //     title: p.playlist_title,
      //     videosCount: p.videos?.length,
      //     videoPagination: p.videoPagination,
      //   })),
      // });
      setPlaylistPagination(isPagination);
      if (playlist_id) {
        // Find the specific playlist in response
        // const targetPlaylist = newData.find((p) => p.playlist_id === playlist_id);
        // console.log('🎯 Looking for playlist:', playlist_id, 'Found:', targetPlaylist ? {
        //   id: targetPlaylist.playlist_id,
        //   videosCount: targetPlaylist.videos?.length,
        //   videoIds: targetPlaylist.videos?.map((v) => v.id),
        //   videoPagination: targetPlaylist.videoPagination,
        // } : 'NOT FOUND');

        setPlaylistData((prevData) => prevData.map((category) => {
          const newCategoryData = newData.find(
            (c) => c.playlist_id === category.playlist_id
          );

          if (newCategoryData) {
            const existingVideoIds = new Set(
              category.videos.map((v) => v.id)
            ); // ✅ Collect existing video IDs
            const newVideos = newCategoryData.videos.filter(
              (video) => !existingVideoIds.has(video.id)
            );
            // console.log('📊 Playlist', category.playlist_id, '- Existing videos:', category.videos.length,
            //   'New unique videos:', newVideos.length,
            //   'Total after merge:', category.videos.length + newVideos.length);
            return {
              ...category,
              videos: [
                ...category.videos,
                ...newVideos, // ✅ Append only unique videos
              ],
              videoPagination: newCategoryData.videoPagination, // ✅ Update pagination info
            };
          }
          return category;
        }));
      } else {
        setPlaylistData((prevData) => {
          const existingCategoryIds = new Set(
            prevData.map((item) => item.playlist_id)
          );
          const uniqueNewData = newData.filter(
            (item) => !existingCategoryIds.has(item.playlist_id)
          );
          return [...prevData, ...uniqueNewData]; // Append only unique categories
        });
      }

      // categoryLoader is owned by the categories fetch (fetchData) so the page
      // body — including the top category bar — reveals only once categories are
      // ready, instead of as soon as playlists return.
      setEndLoader(false);
    } catch (error) {
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'View Projector',
        description: `Failed to load playlists. URL: ${backendUrl}/get-videos-by-playlist`,
        severity: 'high',
        errorMessage: error?.response?.data?.message || error?.message || 'Failed to load playlists',
        responseStatus: error?.response?.status || null,
        responseBody: error?.response?.data?.message || null,
        requestUrl: `${backendUrl}/get-videos-by-playlist`,
        requestMethod: 'POST',
        component: 'Profile',
        userAction: 'View projector called',
      });
      setEndLoader(false);
      console.error('GraphQL Error Playlist:', error);
    }
  };
  const fetchPhotoAlbumData = async (pageOffset) => {
    try {
      const api = `${backendUrl}/get-albums`;
      const query = 'query GetAlbums($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $vpm: Boolean) { albums(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, vpm: $vpm) { albums { id title description icon } pagination { total limit offset hasNextPage hasPreviousPage } } }';

      const variables = {
        userId: Number(profileID),
        limit: 10,
        offset: pageOffset, // ✅ Only use this for page scrolling
        // vpm: true → keep the default album list order (order_number DESC)
        vpm: true,
      };
      const response = await axios.post(
        api,
        { query, variables },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      const newData = response?.data?.data?.albums?.albums || [];
      const isPagination = response?.data?.data?.albums?.pagination;
      setAlbumPagination(isPagination);
      setAlbumData((prev) => {
        const prevIds = new Set(prev.map((v) => v.id));
        const filtered = newData.filter((v) => !prevIds.has(v.id));
        return [...prev, ...filtered]; // ✅ same reference for unchanged items
      });
    } catch (error) {
      logAppEvent({
        userName: `${userDetails?.firstname || ''} ${userDetails?.lastname || ''}`.trim() || 'Guest',
        functionAffected: 'View Projector',
        description: `Failed to load photo albums. URL: ${backendUrl}/get-albums`,
        severity: 'high',
        errorMessage: error?.response?.data?.message || error?.message || 'Failed to load photo albums',
        responseStatus: error?.response?.status || null,
        responseBody: error?.response?.data?.message || null,
        requestUrl: `${backendUrl}/get-albums`,
        requestMethod: 'POST',
        component: 'Profile',
        userAction: 'View projector called',
      });
      setEndLoader(false);
      console.error('GraphQL Error album:', error);
    }
  };
  // ── Silent post-upload refresh ─────────────────────────────────────────────
  // Uploads no longer have to finish before the user leaves the page they were
  // started on — the new-signup /gift-content flow now sends the user onward
  // (ending up here) while its uploads keep running on the global upload
  // manager. Each file that finishes is picked up below and merged into the
  // already-rendered content: no loader, no shimmer, no scroll reset, so the
  // new video/album simply appears.
  //
  // Mirrors of the rendered lists, so the refresh can read the current state
  // without being re-created (and re-subscribed) on every data change.
  const contentDataRef = useRef([]);
  const playlistDataRef = useRef([]);
  useEffect(() => { contentDataRef.current = contentData; }, [contentData]);
  useEffect(() => { playlistDataRef.current = playlistData; }, [playlistData]);

  const silentRefreshTimersRef = useRef([]);
  // Refreshes run one after another (see scheduleSilentRefresh) so two passes
  // can never overlap and double-append the same fresh video.
  const silentRefreshChainRef = useRef(Promise.resolve());
  const silentRefreshUnmountedRef = useRef(false);

  const silentRefreshContent = useCallback(async () => {
    if (silentRefreshUnmountedRef.current) return;

    const currentPlanId = subscriptionDetails?.subscription?.plan_id
      || subscriptionDetails?.plans?.[subscriptionDetails?.plans?.length - 1]?.plan_id;
    const isPlan14 = String(currentPlanId) === '14';
    const sortVars = isPlan14 ? { videoSortBy: 'date', videoSortOrder: 'ASC' } : {};
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    };

    // A freshly registered video is appended to the END of its category, which
    // may sit past the first page we already loaded. So for every category
    // that's on screen we ask for the page that STARTS where our list ends;
    // categories we've never seen come back with the default first page.
    const categoryTails = (contentDataRef.current || [])
      .filter((c) => c?.category_id)
      .map((c) => ({
        categoryId: c.category_id,
        videoLimit: 20,
        videoOffset: c?.videos?.length || 0,
      }));
    const playlistTails = (playlistDataRef.current || [])
      .filter((pl) => pl?.playlist_id)
      .map((pl) => ({
        playlistId: pl.playlist_id,
        videoLimit: 20,
        videoOffset: pl?.videos?.length || 0,
      }));

    // Merge helper: keep what is already rendered, append only what is new.
    const mergeVideos = (existing = [], incoming = []) => {
      const existingIds = new Set(existing.map((v) => v?.id));
      const fresh = incoming.filter((v) => v?.id && !existingIds.has(v.id));
      return fresh.length ? [...existing, ...fresh] : existing;
    };

    const refreshCategories = async () => {
      const query = 'query GetCategories($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $commonVideoLimit: Int, $videoSortBy: String, $videoSortOrder: String, $categoryVideoPagination: [CategoryVideoPaginationInput], $vpm: Boolean) { categories(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, commonVideoLimit: $commonVideoLimit, videoSortBy: $videoSortBy, videoSortOrder: $videoSortOrder, categoryVideoPagination: $categoryVideoPagination, vpm: $vpm) { categories { category_id category_name icon videos { id title thumbnails visibility locked_for } videoPagination { total limit offset hasNextPage hasPreviousPage } } pagination { total limit offset hasNextPage hasPreviousPage } } }';
      const response = await axios.post(
        `${backendUrl}/graphql`,
        {
          query,
          variables: {
            userId: Number(profileID),
            limit: 10,
            offset: 0,
            commonVideoLimit: 10,
            categoryVideoPagination: categoryTails,
            vpm: false,
            ...sortVars,
          },
        },
        { headers }
      );
      const newData = response?.data?.data?.categories?.categories || [];
      if (silentRefreshUnmountedRef.current || newData.length === 0) return;
      setContentData((prev) => {
        const byId = new Map(newData.map((c) => [c.category_id, c]));
        const merged = (prev || []).map((category) => {
          const incoming = byId.get(category?.category_id);
          if (!incoming) return category;
          byId.delete(category.category_id);
          const videos = mergeVideos(category?.videos, incoming?.videos);
          if (videos === category?.videos) return category;
          return { ...category, videos, videoPagination: incoming?.videoPagination || category?.videoPagination };
        });
        // Categories created by this upload (e.g. the signup flow's
        // "<Name>'s videos") aren't on screen yet — append them.
        const brandNew = Array.from(byId.values());
        return brandNew.length ? [...merged, ...brandNew] : merged;
      });
    };

    const refreshPlaylists = async () => {
      if (playlistTails.length === 0) return;
      const query = 'query GetPlaylists($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $commonVideoLimit: Int, $videoSortBy: String, $videoSortOrder: String, $playlistVideoPagination: [PlaylistVideoPaginationInput], $vpm: Boolean) { playlists(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, commonVideoLimit: $commonVideoLimit, videoSortBy: $videoSortBy, videoSortOrder: $videoSortOrder, playlistVideoPagination: $playlistVideoPagination, vpm: $vpm) { playlists { playlist_id playlist_title videos { id title thumbnails visibility locked_for } videoPagination { total limit offset hasNextPage hasPreviousPage } } pagination { total limit offset hasNextPage hasPreviousPage } } }';
      const response = await axios.post(
        `${backendUrl}/get-videos-by-playlist`,
        {
          query,
          variables: {
            userId: Number(profileID),
            limit: 10,
            offset: 0,
            commonVideoLimit: 10,
            playlistVideoPagination: playlistTails,
            vpm: false,
            ...sortVars,
          },
        },
        { headers }
      );
      const newData = response?.data?.data?.playlists?.playlists || [];
      if (silentRefreshUnmountedRef.current || newData.length === 0) return;
      setPlaylistData((prev) => (prev || []).map((pl) => {
        const incoming = newData.find((c) => c?.playlist_id === pl?.playlist_id);
        if (!incoming) return pl;
        const videos = mergeVideos(pl?.videos, incoming?.videos);
        if (videos === pl?.videos) return pl;
        return { ...pl, videos, videoPagination: incoming?.videoPagination || pl?.videoPagination };
      }));
    };

    const refreshAlbums = async () => {
      const query = 'query GetAlbums($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $vpm: Boolean) { albums(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, vpm: $vpm) { albums { id title description icon } pagination { total limit offset hasNextPage hasPreviousPage } } }';
      const response = await axios.post(
        `${backendUrl}/get-albums`,
        {
          query,
          variables: {
            userId: Number(profileID),
            limit: 10,
            offset: 0,
            vpm: true,
          },
        },
        { headers }
      );
      const newData = response?.data?.data?.albums?.albums || [];
      if (silentRefreshUnmountedRef.current || newData.length === 0) return;
      setAlbumData((prev) => {
        const prevIds = new Set((prev || []).map((a) => a?.id));
        const fresh = newData.filter((a) => a?.id && !prevIds.has(a.id));
        // Photos added to an EXISTING album change nothing on this page (album
        // cards render id/title/icon only), so only genuinely new albums matter.
        return fresh.length ? [...(prev || []), ...fresh] : prev;
      });
    };

    await Promise.all([
      refreshCategories().catch((err) => console.warn('[PROFILE] Silent category refresh failed:', err)),
      refreshPlaylists().catch((err) => console.warn('[PROFILE] Silent playlist refresh failed:', err)),
      refreshAlbums().catch((err) => console.warn('[PROFILE] Silent album refresh failed:', err)),
    ]);
  }, [profileID, backendUrl, subscriptionDetails, getToken]);

  // Two passes per completion: one straight away for the common case, one a few
  // seconds later because the backend can take a moment to index a just-
  // registered video. Re-arming clears the pending pair, so a burst of files
  // finishing together collapses into a single pair of refreshes.
  const scheduleSilentRefresh = useCallback(() => {
    const enqueue = () => {
      silentRefreshChainRef.current = silentRefreshChainRef.current
        .then(() => silentRefreshContent())
        .catch(() => {});
    };
    silentRefreshTimersRef.current.forEach((t) => clearTimeout(t));
    silentRefreshTimersRef.current = [
      setTimeout(enqueue, 1200),
      setTimeout(enqueue, 6000),
    ];
  }, [silentRefreshContent]);

  // Watch the global upload manager for files crossing into "completed".
  const seenUploadStatusRef = useRef(new Map());
  useEffect(() => {
    // Only for the signed-in user's own projector — a friend's profile never
    // receives our uploads.
    if (!isMyProfile) return undefined;
    silentRefreshUnmountedRef.current = false;

    const handleSnapshot = ({ uploads: managerUploads }) => {
      if (!managerUploads || managerUploads.length === 0) return;
      let justCompleted = false;
      managerUploads.forEach((u) => {
        const key = u.id || u.draftId;
        if (!key) return;
        const previous = seenUploadStatusRef.current.get(key);
        seenUploadStatusRef.current.set(key, u.status);
        if (u.status === UPLOAD_STATUS.COMPLETED && previous !== UPLOAD_STATUS.COMPLETED) {
          justCompleted = true;
        }
      });
      if (justCompleted) scheduleSilentRefresh();
    };

    // Seed from the current snapshot, then follow every change. A file that
    // finished in the gap between navigation and this subscription still shows
    // up as a first-observation completion and triggers the refresh.
    handleSnapshot(uploadManagerSecure.getSnapshot());
    const unsubscribe = uploadManagerSecure.subscribe(handleSnapshot);

    return () => {
      silentRefreshUnmountedRef.current = true;
      silentRefreshTimersRef.current.forEach((t) => clearTimeout(t));
      silentRefreshTimersRef.current = [];
      unsubscribe();
    };
  }, [isMyProfile, scheduleSilentRefresh]);

  const processQueue = () => {
    if (fetchQueue.current.length === 0 || promiseLock.current) return;

    const {
      pageOffset, category_id, categoryVideoOffset, onDone,
    } = fetchQueue.current.shift();

    // Create a new promise to lock the process
    promiseLock.current = {};
    promiseLock.current.promise = new Promise((resolve) => {
      promiseLock.current.resolve = resolve;
    });

    fetchData(pageOffset, category_id, categoryVideoOffset).then(() => {
      if (onDone) onDone();
      processQueue(); // Process the next item after the current one resolves
    });
  };

  // Add a fetch request to the queue
  const queueFetchData = (pageOffset, category_id, categoryVideoOffset, onDone) => {
    fetchQueue.current.push({
      pageOffset, category_id, categoryVideoOffset, onDone,
    });
    if (!promiseLock.current) {
      processQueue(); // Start processing if no lock is active
    }
  };
  const [categoryOffset, setCategoryOffset] = useState(0);
  const [playlistOffset, setPlaylistOffset] = useState(0);

  /* Infinite scroll, ONE page per trigger.
     `scroll` fires continuously — dozens of events for a single flick — and
     `hasNextPage` only changes once a response lands, so the old version queued
     a new page on EVERY event while scrolled past the threshold: the offset ran
     away (…190, 200, 210) and GetCategories was called non-stop.
     These refs are the gate. A page is requested only when no request for that
     section is already in flight, and the offset is tracked on the ref (not
     derived inside a setState updater, which React may run twice) so the same
     offset can never be requested twice. */
  const loadingMoreCategories = useRef(false);
  const loadingMorePlaylists = useRef(false);
  const categoryOffsetRef = useRef(0);
  const playlistOffsetRef = useRef(0);

  const loadMoreCategories = () => {
    if (loadingMoreCategories.current) return;
    loadingMoreCategories.current = true;
    const newOffset = categoryOffsetRef.current + 10;
    categoryOffsetRef.current = newOffset;
    setCategoryOffset(newOffset);
    setEndLoader(true);
    queueFetchData(newOffset, null, null, () => {
      loadingMoreCategories.current = false;
    });
  };

  const loadMorePlaylists = () => {
    if (loadingMorePlaylists.current) return;
    loadingMorePlaylists.current = true;
    const newOffset = playlistOffsetRef.current + 10;
    playlistOffsetRef.current = newOffset;
    setPlaylistOffset(newOffset);
    setEndLoader(true);
    Promise.resolve(fetchPlaylistData(newOffset, null, null)).finally(() => {
      loadingMorePlaylists.current = false;
    });
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.offsetHeight;

    const scrollPercentage = (scrollTop + windowHeight) / documentHeight;

    if (scrollPercentage >= 0.5) {
      if (categoriPagination?.hasNextPage) loadMoreCategories();
      if (playlistPagination?.hasNextPage) loadMorePlaylists();
    }
  };
  const addMoreContents = () => {
    if (categoriPagination?.hasNextPage) loadMoreCategories();
    if (playlistPagination?.hasNextPage) loadMorePlaylists();
  };
  // Attach scroll listener. Both flags matter — with only the category one in
  // the deps, the handler kept a stale playlistPagination in its closure.
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [categoriPagination?.hasNextPage, playlistPagination?.hasNextPage]);
  const fetchResumeData = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/v1/getUserContentsResumes`,
        {
          user_id: profileID,
        }
      );
      setResumeMe(response?.data);
      // setcategoryLoader(false);
    } catch (error) {
      const responseData = error?.response?.data;
      // setcategoryLoader(false);
    }
  };
  const fetchFirstFiles = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/${endpoints.getFirstFiles}`,
        {
          token: getToken(),
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      // Store allowed video and album IDs in localStorage for permission checking
      if (response?.data?.success && response?.data?.data) {
        const { videos, albums } = response.data.data;

        // Extract video IDs
        if (Array.isArray(videos)) {
          const allowedVideoIds = videos.map((video) => String(video.id));
          localStorage.setItem('allowedVideoIds', JSON.stringify(allowedVideoIds));
        }

        // Extract album IDs
        if (Array.isArray(albums)) {
          const allowedAlbumIds = albums.map((album) => String(album.id));
          localStorage.setItem('allowedAlbumIds', JSON.stringify(allowedAlbumIds));
        }
      }

      setFirst15Videos(response?.data);
    } catch (error) {
      const responseData = error?.response?.data;
    }
  };
  const callForUpdate = () => {
    const apiUrl = `${baseUrl}/v1/loadUserContents`;
    const postData = {
      token: getToken(),
      user_id: profileID,
      pass_from: 'web on payload',
    };
    axios
      .post(apiUrl, postData)
      .then((response) => response.data)
      .catch((error) => {
        console.error('err', error);
      });
  };
  useEffect(() => {
    // if (!orderArrange?.[profileID] || orderArrange?.[profileID].length === 0) {
    //   fetchLayoutOrder(Number(profileID));
    // }
    fetchLayoutOrder(Number(profileID));
  }, []);

  // Track if subscriptionDetails has loaded
  const subscriptionLoaded = !!subscriptionDetails;

  useEffect(() => {
    // Wait for subscriptionDetails to load before fetching
    if (!subscriptionLoaded) return;

    // Returning from the inner page: restore the cached view instead of
    // refetching (one-shot flag). Only when the cache matches this profile.
    if (
      sessionStorage.getItem('skipProfileRefetch') === String(profileID)
      && profileDataCache?.profileID === String(profileID)
    ) {
      sessionStorage.removeItem('skipProfileRefetch');
      setContentData(profileDataCache.contentData || []);
      setPlaylistData(profileDataCache.playlistData || []);
      setAlbumData(profileDataCache.albumData || []);
      setLoader(false);
      setcategoryLoader(false);
      setInitialLoadDone(true);
      return;
    }

    const fetchAllData = async () => {
      setInitialLoadDone(false);
      setcategoryLoader(true);
      setLoader(true);

      // Reset states
      setPlaylistData([]);
      setAlbumData([]);
      setContentData([]);
      setOffset(0);
      // Paging starts over for this profile: drop the queue, the in-flight
      // flags and the offsets, or the first scroll would resume from the
      // previous projector's page number.
      fetchQueue.current = [];
      loadingMoreCategories.current = false;
      loadingMorePlaylists.current = false;
      categoryOffsetRef.current = 0;
      playlistOffsetRef.current = 0;
      setCategoryOffset(0);
      setPlaylistOffset(0);

      try {
        // getFirstFiles' result isn't rendered on this page — fire-and-forget so
        // it never blocks the content reveal (was inside the awaited group).
        fetchFirstFiles();
        // Run the calls that actually feed the page in parallel.
        // The shimmer is released as soon as the CATEGORIES call lands — that's
        // the content the skeleton is a placeholder for. Waiting on all four
        // held the shimmer up for however long the slowest of playlists /
        // albums / resume-watching took, even though categories were ready.
        // Those three rows render themselves as their data arrives.
        const categories = fetchData(0);
        categories.finally(() => setInitialLoadDone(true));
        await Promise.all([
          categories,
          fetchPlaylistData(0),
          fetchPhotoAlbumData(0),
          fetchResumeData(),
        ]);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoader(false);
        setInitialLoadDone(true);
      }
    };

    fetchAllData();
  }, [profileID, subscriptionLoaded]);

  // Keep the back-navigation cache current with what's on screen.
  useEffect(() => {
    if (loader) return;
    if (contentData?.length || playlistData?.length || albumData?.length) {
      profileDataCache = {
        profileID: String(profileID),
        contentData,
        playlistData,
        albumData,
      };
    }
  }, [loader, contentData, playlistData, albumData, profileID]);

  const path = window.location.origin === 'https://projector.app'
    ? 'projector_contents'
    : 'pre_projector_contents';
  const firstVideosSnapshotRef = useRef(true);
  useEffect(() => {
    const databaseRefGetVideos = ref(
      firebaseDatabase,
      `${path}/${localStorage.getItem('id')}`
    );
    const dataCallbackVideos = (snapshot) => {
      // Skip the immediate snapshot Firebase fires on attach — fetchAllData
      // already loaded page 0; only refetch on later real-time changes.
      if (firstVideosSnapshotRef.current) {
        firstVideosSnapshotRef.current = false;
        return;
      }
      if (snapshot.exists()) {
        // fetchResumeData();
        fetchData(offset);
        fetchPlaylistData(offset);
      }
    };
    onValue(databaseRefGetVideos, dataCallbackVideos);
    return () => {
      off(databaseRefGetVideos, 'value', dataCallbackVideos);
    };
  }, []);
  const { mutate: getMyPausedList } = useSWR(
    [endpoints.getMyPausedList, profileID],
    {
      fetcher: (url, user_id) => dataFetcher(url, { user_id }),
      onSuccess: ({ success, paused, message }) => {
        // Note: categoryLoader is intentionally NOT cleared here — it is owned
        // by the categories fetch (fetchData) so the page body reveals only once
        // the top category bar's data is ready.
        if (!success) {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message: message || 'Oops! Something went wrong',
          });
        }
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        const responseData = error?.response?.data;
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: responseData?.message || 'Oops! Something went wrong',
        });
      },
    }
  );
  const { mutate: clearResumeWatching } = useSWR(
    [endpoints.clearResumeList, profileID],
    {
      fetcher: (url, user_id) => dataFetcher(url, { user_id }),
      onSuccess: ({ success, message }) => {
        if (success) {
          fetchResumeData();
          // fetchData();
          getMyPausedList();
        } else {
          setAppSnackbar({ isVisible: true, type: 'error', message });
        }
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message:
            error?.response?.data?.message || 'Oops! Something went wrong',
        });
      },
    }
  );

  useEffect(() => {
    getMyPausedList();
  }, [profileID]);

  useEffect(() => {
    setNeedToShowETA(false);
    // Clear the global navigation spinner right away — the shimmer skeleton is
    // the page's loader now. Lingering on it for 3s made the spinner, progress
    // bar and shimmer stack up and glitch on load.
    setContextLoading(false);
  }, []);

  // const uniqueContentTypes = contentData?.data?.map((item) => item?.content_type);

  const uniqueContentTypes = Array.isArray(contentData?.data)
    ? contentData.data
      .sort((a, b) => (a?.order_number || 0) - (b?.order_number || 0))
      .map((item) => item?.content_type)
    : [];

  // Function to check if any content data is non-empty
  const checkContent = (content, playlist, album) => {
    const hasData = (input) => Array.isArray(input?.data)
      && input.data.some(
        (item) => Array.isArray(item?.data) && item.data.length > 0
      );

    return hasData(content) || hasData(playlist) || hasData(album);
  };

  useEffect(() => {
    setHasContent(checkContent(contentData, playlistData, albumData));
  }, [contentData, playlistData, albumData]);
  // useEffect(() => {
  //   if (contentData || playlistData || albumData) {
  //     setLoader(false);
  //   }
  // }, [hasContent, setLoading]);

  const categoryHead = Array.isArray(contentData?.data)
    ? contentData.data.find((item) => item?.content_type === 'categories')?.data
    : undefined;

  // Filter categories: exclude "All Videos" if it has no videos
  // Also exclude any other category that has no videos
  const filteredContentData = useMemo(() => {
    if (!contentData || contentData.length === 0) return [];

    const filtered = contentData.filter((category) => {
      const isAllVideos = category?.category_name?.toLowerCase() === 'all videos';
      const hasVideos = category?.videos && category.videos.length > 0;

      // If it's "All Videos" and has no videos, exclude it
      if (isAllVideos && !hasVideos) {
        return false;
      }

      // For all other categories, only show if they have videos
      if (!hasVideos) {
        return false;
      }

      return true;
    });

    return filtered;
  }, [contentData]);

  const defaultOrder = [
    { content_type_id: 1, order_number: 1 },
    { content_type_id: 2, order_number: 2 },
    { content_type_id: 3, order_number: 3 },
  ];

  // Get the user's layout order or fallback
  const profileOrder = orderArrange?.[Number(profileID)]?.length
    ? [...orderArrange[Number(profileID)]]
    : defaultOrder;

  // Config map
  const contentTypeMap = {
    1: {
      fetchData,
      offset,
      responseData: filteredContentData,
      type: CONTENT_TYPES.categories,
      pagination: categoriPagination,
    },
    2: {
      fetchData: fetchPlaylistData,
      offset,
      responseData: playlistData,
      type: CONTENT_TYPES.playlists,
      pagination: playlistPagination,
    },
    3: {
      fetchData: fetchPhotoAlbumData,
      offset,
      responseData: albumData,
      type: CONTENT_TYPES.photo_albums,
      albumPagination,
      profileDetails: profileDetails?.firstname,
    },
  };
  // const navigationConfig = {};
  // if (video.haspre) navigationConfig.prevEl = '#custom-prev';
  // if (video.hasnext) navigationConfig.nextEl = '#custom-next';
  const [activeSection, setActiveSection] = useState('home');
  const sectionIdMap = { 1: 'categories', 2: 'playlist', 3: 'albums' };
  const handleScrollToSection = (section) => {
    if (section === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const el = document.getElementById(`section-${section}`);
      if (el) {
        // Offset for the floating nav pill so the heading clears it instead of
        // hiding underneath.
        const y = el.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    }
    setActiveSection(section);
  };

  const slidesPerView = window.innerWidth >= 640 ? 4 : 3;
  const hasScrollableSlides = contentData?.length > slidesPerView;
  const [swiperStates, setSwiperStates] = useState({
    atBeginning: true,
    atEnd: false,
    hasScrollableSlides: false,
  });
  const updateSwiperStates = (swiper) => {
    setSwiperStates({
      atBeginning: swiper.isBeginning,
      atEnd: swiper.isEnd,
      hasScrollableSlides: swiper.slides.length > swiper.params.slidesPerView,
    });
  };

  // console.log(
  //   'hasScrollableSlides',
  //   swiperStates?.atEnd,
  //   categoriPagination?.hasNextPage
  // );
  // Hover a category tile → popover with that category's videos (horizontal
  // strip). A short close-delay lets the cursor travel into the popover.
  const [hoverCat, setHoverCat] = useState(null);
  // Viewport-clamped top for the category popover (see the layout effect below).
  const [catPopTop, setCatPopTop] = useState(null);
  const [modalVideo, setModalVideo] = useState(null);
  // Context (from/playlist_id/category_id/...) for the in-place video modal, so
  // the v2 details/player endpoint returns the correct ordered "more videos".
  const [modalCtx, setModalCtx] = useState(undefined);
  const openVideoModal = (id, ctx = undefined) => {
    setModalVideo(id);
    setModalCtx(ctx);
  };
  const [albumModalId, setAlbumModalId] = useState(null);
  // Projector background preset (set on the Layout tab). Local for now — the
  // per-owner value comes from the API later; here it themes the owner's page.
  const [profileBg, setProfileBg] = useState(() => readProfileBg());
  // API-sourced background for the projector being viewed (getMyProfile for self,
  // getAllViewRequestSent for others). Only my own page uses the local live
  // preview — another projector's value is authoritative (incl. '' = Default),
  // otherwise we'd wrongly paint their page with the viewer's own saved colour.
  const ownerBg = useProjectorBg(profileID);
  const effectiveBg = isMyProfile ? (profileBg || ownerBg) : ownerBg;
  useEffect(() => {
    const onChange = () => setProfileBg(readProfileBg());
    window.addEventListener('profileBg:change', onChange);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener('profileBg:change', onChange);
      window.removeEventListener('storage', onChange);
    };
  }, []);
  const hoverCloseTimer = useRef(null);
  const hoverOpenTimer = useRef(null);
  const catPopRef = useRef(null);
  const openCatHover = (index, el) => {
    if (hoverCloseTimer.current) clearTimeout(hoverCloseTimer.current);
    if (hoverOpenTimer.current) clearTimeout(hoverOpenTimer.current);
    // Open only after a dwell so a quick pass-over doesn't flash it (1.5× the
    // previous 1000ms so it takes a more deliberate hover to trigger).
    hoverOpenTimer.current = setTimeout(() => {
      // Measure when the popover actually opens, not on mouseenter: the row can
      // be scrolled during the 1.5s dwell, which would pin the clone to a stale
      // position.
      const rect = el.getBoundingClientRect();
      // The clone is position:fixed, so unlike the real tile it is NOT clipped
      // by the row's scroll track. Hovering a tile that sits half-scrolled out
      // of the row therefore painted it in full, sticking out past the row's
      // edge (and off the page). Clip away exactly the out-of-row part so the
      // clone covers the tile and nothing else.
      const track = el.closest('.rc-track');
      const bounds = track ? track.getBoundingClientRect() : null;
      const clip = bounds
        ? {
          left: Math.max(0, bounds.left - rect.left),
          right: Math.max(0, rect.right - bounds.right),
        }
        : { left: 0, right: 0 };
      setHoverCat({ index, rect, clip });
    }, 1500);
  };
  const scheduleCatHoverClose = () => {
    if (hoverOpenTimer.current) clearTimeout(hoverOpenTimer.current);
    if (hoverCloseTimer.current) clearTimeout(hoverCloseTimer.current);
    // Fast dismissal so the popover doesn't feel like an obstruction.
    hoverCloseTimer.current = setTimeout(() => setHoverCat(null), 200);
  };
  const cancelCatHoverClose = () => {
    if (hoverCloseTimer.current) clearTimeout(hoverCloseTimer.current);
  };
  // Magic Bento glow: track the cursor within a card so its border/spotlight
  // lights up under the pointer.
  const handleCardGlow = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty('--gx', `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty('--gy', `${e.clientY - r.top}px`);
  };
  // Scrolling should dismiss the category popover instantly (fixed-position — it'd
  // otherwise sit over the content and feel like an obstruction).
  useEffect(() => {
    if (hoverCat == null) return undefined;
    const close = (e) => {
      // Don't dismiss while the user is scrolling within the popover itself
      // (e.g. its video RowCarousel) — only page-level scroll should close it.
      if (catPopRef.current && e && catPopRef.current.contains(e.target)) return;
      if (hoverOpenTimer.current) clearTimeout(hoverOpenTimer.current);
      setHoverCat(null);
    };
    // NOTE: no `capture: true` — with capture, this fires on scroll events from
    // ANY child element (e.g. the RowCarousel track), which closed the popover
    // the instant it opened. Without it, only page-level scroll dismisses.
    window.addEventListener('wheel', close, { passive: true });
    window.addEventListener('scroll', close, { passive: true });
    return () => {
      window.removeEventListener('wheel', close);
      window.removeEventListener('scroll', close);
    };
  }, [hoverCat]);
  // Keep the popover inside the viewport. It opens under the hovered tile, so a
  // category row sitting low on screen pushed it past the bottom edge and its
  // video cards were cut off. Flip it above the tile when it doesn't fit below,
  // and clamp as a last resort. useLayoutEffect (not useEffect) so the corrected
  // position is applied before the browser paints — no visible jump.
  useLayoutEffect(() => {
    if (hoverCat == null) {
      setCatPopTop(null);
      return;
    }
    const el = catPopRef.current;
    if (!el) return;
    const GAP = 8;
    const EDGE = 12;
    const h = el.offsetHeight;
    const below = hoverCat.rect.bottom + GAP;
    if (below + h <= window.innerHeight - EDGE) {
      setCatPopTop(below);
      return;
    }
    const above = hoverCat.rect.top - GAP - h;
    setCatPopTop(above >= EDGE ? above : Math.max(EDGE, window.innerHeight - h - EDGE));
  }, [hoverCat]);

  const parseThumb = (thumbnails) => {
    try {
      return (Array.isArray(thumbnails) ? thumbnails[0] : JSON.parse(thumbnails)?.[0]) || '';
    } catch (e) {
      return '';
    }
  };

  // Left-edge OptionWheel: jump to a content section, in the user's order.
  const SECTION_LABELS = { 1: 'Categories', 2: 'Playlists', 3: 'Albums' };
  const SECTION_ICON = { 1: AnimatedCategory, 2: AnimatedPlaylist, 3: AnimatedAlbum };
  const wheelItems = (profileOrder || [])
    .slice()
    .sort((a, b) => Number(a?.order_number) - Number(b?.order_number))
    .map(({ content_type_id }) => ({
      id: sectionIdMap[content_type_id],
      label: SECTION_LABELS[content_type_id],
      Icon: SECTION_ICON[content_type_id],
    }))
    .filter((it) => it.id && it.label);

  return (
    <>
      <div
        className={styles.auroraLayer}
        aria-hidden="true"
        style={{ background: bgSurface(effectiveBg) }}
      >
        {/* Soft Aurora — the /access backdrop, and the product default: it
            covers both '' (Default) and the explicit sentinel, running over the
            black base bgSurface() paints for it. Deep Aurora is the original
            backdrop, its dimmed shader over the mixed gradient. */}
        {fxKind(effectiveBg) === 'soft' && <SoftAuroraFX />}
        {fxKind(effectiveBg) === 'deep' && <ProjectorAuroraFX />}
      </div>
      {/* Left-edge quick-nav moved to the top navigation header (Categories /
          Playlists / Albums icons, alongside Search / Watchlist) — see
          Components/header/index.jsx's viewerNavGroup. */}
      {/* <OptionWheel
        items={wheelItems}
        activeId={activeSection}
        onSelect={handleScrollToSection}
      /> */}
      {/* The page already shows its own skeleton (.pageSkeleton) while it loads,
          so this top blue indeterminate bar was a second, overlapping loader that
          the old UI never had — it flashed in after the skeleton cleared while the
          content fetches finished. Only the visual is dropped; `loader` still
          drives everything else (skeleton, row gating, pagination). */}
      {/* {loader && subscriptionLoaded && categoryLoader !== true && <FixedProgressBar />} */}
      <BottomBar
        onScrollToSection={handleScrollToSection}
        activeSection={activeSection}
        hasCategories={filteredContentData?.length > 0}
        hasAlbums={albumData?.length > 0}
        hasPlaylists={playlistData?.length > 0}
      />
      {/* Shimmer until the categories call lands (`initialLoadDone` /
         `categoryLoader`), which is also what the removed blue FixedProgressBar
         covered. It is deliberately NOT gated on `loader` — that stays true
         until the slower playlist/album/resume calls finish too, and holding the
         skeleton for those made the shimmer outlast the data by seconds. */}
      {!initialLoadDone || categoryLoader === true || !subscriptionLoaded ? (
        <div className={styles.pageSkeleton}>
          <div className={styles.skelTopbar}>
            <div className={styles.skelName} />
            <div className={styles.skelAvatar} />
          </div>
          {[0, 1, 2, 3].map((s) => (
            <div key={s} className={styles.skelSection}>
              <div className={styles.skelHeading} />
              <div className={styles.skelRow}>
                {[0, 1, 2, 3, 4].map((c) => (
                  <div key={c} className={styles.skelCard} />
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <ProfilePage
          containerClassName={cn({
            [styles.pageContainer]: true,
            [styles.pageContainerVideoBanner]: layoutType === 4,
          })}
          mainClassName={cn({
            [styles.mainContent]: true,
            [styles.loading]: loading,
          })}
          userName={profileName}
          isProfileHeader
          /* The projector surface is painted by .auroraLayer above (the chosen
             dark preset, or the Default aurora). Without this, Page adds its
             light app chrome — a #faf8f8 base + the pale-blue SoftAurora blobs
             — on top, and every dark theme reads as a washed-out blue-grey. */
          noDefaultBg
          userProfileLink={Pathname.getFriendProfilePath(profileID)}
          videoBanner={layoutType === 4}
          layoutData={layoutData}
        >
          {profileLoader === true && categoryLoader === true ? (
            <div className={styles.ending}>
              <ThreeDotLoader />
            </div>
          ) : (
            // <div className={styles.headingText}>
            //   {profileDetails?.firstname === 'Tutorials'
            //     ? profileDetails?.firstname
            //     : `${profileDetails?.firstname?.trim()}'s Projector`}
            // </div>
            (
<div>
              <div className={styles.headingText}>
                {profileDetails?.display_name
                  ? `${profileDetails.display_name}'s Projector`
                  : profileDetails?.firstname
                    ? profileDetails.firstname === 'Tutorials'
                      ? 'Tutorials'
                      : `${getDisplayName(`${profileDetails.firstname} ${profileDetails.lastname || ''}`.trim())}'s Projector`
                    : ''}
              </div>
              {!profileDetails?.firstname && (
                <div className={styles.noNameSubtext}>
                  Make your content more aesthetic by adding a Profile name.
                  {' '}
                  <Link to={Pathname.getSettingsPath('/accounts')} className={styles.updateLink}>
                    Update now
                  </Link>
                </div>
              )}
</div>
)
          )}
          {/* Gated on the categories themselves, NOT on `loader`: `loader` stays
             true until the playlist/album/resume calls finish, so this strip —
             the page's primary navigation — used to pop in last, after the
             content rows below it had already rendered. */}
          {filteredContentData?.length > 0 && categoryLoader !== true && (
            <RowCarousel className={styles.categoryRow}>
              {filteredContentData.map((cat, idx) => {
                // Shared by the click and keyboard handlers below, so the tile is
                // operable by Enter/Space as its role="button" already implies.
                const openCategory = () => {
                  setSelectedCategoryID(cat.category_id);
                  setSelectedCategoryTitle(cat.category_name);
                  setThumbnail(cat.icon);
                  localStorage.setItem('prevlocation', 'innerpage');
                  navigate(`/innerpage${isFromGift ? '?fromGift=true' : ''}`, {
                    state: {
                      category_name: cat.category_name,
                      category_id: cat.category_id,
                      icon: cat.icon,
                      profile_id: profileID,
                      // Ordered category list + position so the inner page can
                      // offer a "next category" jump.
                      categories: filteredContentData.map((c) => ({
                        category_id: c.category_id,
                        category_name: c.category_name,
                        icon: c.icon,
                      })),
                      index: idx,
                    },
                  });
                };
                return (
                  <div
                    key={cat.category_id}
                    className={styles.catTile}
                    role="button"
                    tabIndex={0}
                    style={{
                      backgroundImage: `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.6)), url(${cat.icon || cat.imagekit_icon})`,
                    }}
                    onMouseEnter={(e) => openCatHover(idx, e.currentTarget)}
                    onMouseLeave={scheduleCatHoverClose}
                    onClick={openCategory}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        openCategory();
                      }
                    }}
                  >
                    <span className={styles.catTileName}>{cat.category_name}</span>
                  </div>
                );
              })}
            </RowCarousel>
          )}
          <div>
            {filteredContentData?.length > 0
              || playlistData?.length > 0
              || albumData?.length > 0 ? (
              <>
                {resumeMe?.data && (
                  <ViewMyProjector
                    key="resumeMe"
                    fetchData={fetchResumeData} // your fetch function for resume
                    responseData={resumeMe?.data[0]}
                    isGrid
                    type={CONTENT_TYPES.resume}
                    clearResumeWatching={clearResumeWatching}
                    hideVideoTitles={isFromGift}
                    onShowPermissionModal={() => {
                      setShowPermissionModal(true);
                    }}
                    onVideoOpen={openVideoModal}
                    onAlbumOpen={setAlbumModalId}
                  />
                )}
                {profileOrder
                  ?.sort(
                    (a, b) => Number(a?.order_number) - Number(b?.order_number)
                  )
                  ?.map(({ content_type_id }, index) => {
                    const config = contentTypeMap[content_type_id];
                    if (!config) return null;

                    return (
                      <div key={index} id={`section-${sectionIdMap[content_type_id] || ''}`}>
                      <ViewMyProjector
                        pagination={config.pagination}
                        fetchData={config.fetchData}
                        offset={config.offset}
                        responseData={config.responseData}
                        setVideoOffset={setVideoOffset}
                        isGrid
                        type={config.type}
                        {...(config.albumPagination && {
                          albumPagination: config.albumPagination,
                        })}
                        {...(config.profileDetails && {
                          profileDetails: config.profileDetails,
                        })}
                        hideVideoTitles={isFromGift}
                        onShowPermissionModal={() => {
                          setShowPermissionModal(true);
                        }}
                        onVideoOpen={openVideoModal}
                        onAlbumOpen={setAlbumModalId}
                      />
                      </div>
                    );
                  })}
              </>
            ) : loader === false && initialLoadDone ? (
              /* Only a FINISHED load with nothing in it is empty. The skeleton
                 clears when `categoryLoader` flips (categories fetched), but the
                 content/playlist/album fetches are still in flight for a moment
                 after that — during which all three arrays are empty and this
                 used to flash "No Content..." before the rows appeared. */
              <h2
                style={{
                  margin: '0',
                  textAlign: 'center',
                  color: 'white',
                  fontSize: '1.5rem',
                  fontWeight: '500',
                  padding: '10rem',
                }}
              >
                No Content...
              </h2>
            ) : null}
          </div>
        </ProfilePage>
      )}
      {hoverCat != null
        && filteredContentData[hoverCat.index]?.videos?.length > 0 && (
        <>
          <div className={styles.catHoverBackdrop} aria-hidden="true" />
          <div
            className={styles.catHoverHighlight}
            aria-hidden="true"
            style={{
              left: hoverCat.rect.left,
              top: hoverCat.rect.top,
              width: hoverCat.rect.width,
              height: hoverCat.rect.height,
              clipPath: hoverCat.clip && (hoverCat.clip.left || hoverCat.clip.right)
                ? `inset(0px ${hoverCat.clip.right}px 0px ${hoverCat.clip.left}px)`
                : undefined,
              backgroundImage: `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.6)), url(${filteredContentData[hoverCat.index].icon || filteredContentData[hoverCat.index].imagekit_icon})`,
            }}
          >
            <span className={styles.catHoverHighlightName}>
              {filteredContentData[hoverCat.index].category_name}
            </span>
          </div>
          <div
            ref={catPopRef}
            className={styles.catHoverPop}
            style={{
              left: Math.max(12, Math.min(hoverCat.rect.left, window.innerWidth - 1050)),
              top: catPopTop ?? hoverCat.rect.bottom + 8,
            }}
            onMouseEnter={cancelCatHoverClose}
            onMouseLeave={scheduleCatHoverClose}
          >
            <div className={styles.catHoverTitle}>
              {filteredContentData[hoverCat.index].category_name}
            </div>
            <RowCarousel gap={14}>
              {filteredContentData[hoverCat.index].videos.map((v) => (
                <div
                  key={v.id}
                  className={styles.vidCard}
                  role="button"
                  tabIndex={0}
                  onMouseMove={handleCardGlow}
                  onClick={() => { setHoverCat(null); openVideoModal(v.id, { from: 'category', category_id: filteredContentData[hoverCat.index].category_id }); }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setHoverCat(null);
                      openVideoModal(v.id, { from: 'category', category_id: filteredContentData[hoverCat.index].category_id });
                    }
                  }}
                >
                  <div className={styles.vidCardThumb}>
                    <img
                      src={parseThumb(v.thumbnails)}
                      alt={v.title || ''}
                      loading="lazy"
                      decoding="async"
                      ref={(el) => { if (el && el.complete) el.setAttribute('data-loaded', 'true'); }}
                      onLoad={(e) => { e.currentTarget.dataset.loaded = 'true'; }}
                      onError={(e) => { e.currentTarget.dataset.loaded = 'true'; }}
                    />
                  </div>
                  <div className={styles.vidCardBody}>
                    <div className={styles.vidCardTitle}>{v.title}</div>
                    {v.description ? (
                      <div className={styles.vidCardDesc}>{v.description}</div>
                    ) : null}
                  </div>
                </div>
              ))}
            </RowCarousel>
          </div>
        </>
      )}
      {modalVideo != null && (
        <VideoModal
          key={modalVideo}
          videoID={modalVideo}
          navContext={modalCtx}
          isFromGift={isFromGift}
          onClose={() => { setModalVideo(null); setModalCtx(undefined); }}
          onOpenVideo={openVideoModal}
        />
      )}
      {albumModalId != null && (
        <AlbumModal
          key={albumModalId}
          albumID={albumModalId}
          onClose={() => setAlbumModalId(null)}
        />
      )}
      {/* Permission Denied Modal */}
      <PermissionDeniedModal
        open={showPermissionModal}
        onClose={() => {
          setShowPermissionModal(false);
        }}
      />
    </>
  );
};
